import { DateTime } from 'luxon';

export function FormatLocalDateStringBorder(value) {
    if (!value) return "-";

    const isoString = value instanceof Date ? value.toISOString() : value;
    const dt = DateTime.fromISO(isoString, { zone: 'utc' });

    return dt.isValid ? dt.toFormat('MM/dd/yyyy') : "-";
}
